import { IGrupos } from '../../interface';
import { useGrupo } from '../../hooks/useGrupos';
import { useGrupoContext } from '../../context/GroupContext';
import { DragAndDropsGrupos } from '../DragAndDropsGrupos';
import { Modal, Button, Spin } from 'antd';
import { useEffect, useState } from 'react';

interface IModalOrganizarGrupoProps {
    hook: ReturnType<typeof useGrupo>;
}

export const ModalOrganizarGrupo = ({ hook }: IModalOrganizarGrupoProps) => {

    const {
        isOrganizarOpen,
        fecharModalGrupo,
    } = useGrupoContext();

    const {
        grupos,
        loading,
        loadingGrupoModal,
        updateGruposOrdem,
    } = hook;

    const [gruposOrdenados, setGruposOrdenados] = useState<IGrupos[]>([]);

    useEffect(() => {
        if (isOrganizarOpen) {
            setGruposOrdenados([...grupos]);
        }
    }, [isOrganizarOpen, grupos]);

    const handleFinish = async () => {
        await updateGruposOrdem(gruposOrdenados);
        fecharModalGrupo();
    };

    return (
        <Modal
            destroyOnClose
            width={'60%'}
            title={'Organizar ordem de exibição de grupos'}
            open={isOrganizarOpen}
            onCancel={fecharModalGrupo}
            zIndex={1100}
            footer={[
                <Button
                    key="back"
                    onClick={fecharModalGrupo}
                >
                    Fechar
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    disabled={loadingGrupoModal}
                    loading={loadingGrupoModal}
                    style={{
                        backgroundColor: '#008000',
                        borderColor: '#008000',
                    }}
                    onClick={handleFinish}
                >
                    Salvar
                </Button>
            ]}
        >
            <Spin spinning={loadingGrupoModal}>
                <DragAndDropsGrupos
                    grupos={gruposOrdenados}
                    setGrupos={setGruposOrdenados}
                />
            </Spin>
        </Modal>
    );
};
